import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import axios from '../../axios'
import Alert from 'react-s-alert'
import CustomModal from '../../components/CustomModal'
import qs from 'qs'
import Paging from '../../components/Paging'
import FormDropdown from '../../components/FormDropdown';
import ModalHelp from "../../components/ModalHelp";


class Lists extends Component {

    constructor() {
        super();
        this.state = {
            data_siswaKelas   : [],
            dataKelasAsal : [],
            dataKelasTujuan : [],
            data_tahun_ajar:[],
            data_siswaKelas_tujuan : [],
            user_id : "",
            siswa_id:"",
            tahun_ajar:"",
            thn_ajar_value:"",
            kelas_id : "",
            kelas_id_tujuan:"",
            kelas_nama : "",
            pageCount    : 0,
            currentPage  : 0,
            pageCountTujuan    : 0,
            currentPageTujuan  : 0,
            isLoading    : false,
            tutorial: '',
            isModalHelpShow  : false,
            isModalShow  : false,
            isModalShowDelete  : false,
            checked:false,
            selected:[],
            isAll:false,
            value: null
        }

        this.toggleModalDelete         = this.toggleModalDelete.bind(this)
        this.toggleModal              = this.toggleModal.bind(this)
        this.handleChange               = this.handleChange.bind(this)
        this.handleSubmitButton = this.handleSubmitButton.bind(this)
        this.handleSubmitDeleteButton = this.handleSubmitDeleteButton.bind(this)
        this.handleChangeOptionTrue = this.handleChangeOptionTrue.bind(this);
        this.handleChangeOptionAll = this.handleChangeOptionAll.bind(this);
        this.toggleModalHelp                = this.toggleModalHelp.bind(this)
    }
    toggleModalHelp() {

        this.setState({tutorial : 'https://www.youtube.com/embed/jXCoQoYUWRg'})

        this.setState({ isModalHelpShow: ! this.state.isModalHelpShow })
    }


    toggleModal() {
        this.setState({ isModalShow: ! this.state.isModalShow })
    }
    
    toggleModalDelete() {
        this.setState({ isModalShowDelete: ! this.state.isModalShowDelete })
    }

    handleSubmitDeleteButton() {

        const params = qs.stringify({
            kelas_id_tujuan:this.state.kelas_id_tujuan,
            siswa_id:this.state.siswa_id,
            user_id:localStorage.SISMART_USER_ID

        })

        axios({
            method: 'post',
            url: '/naik_kelas/delete?' + params
        })
            .then(response => {

                Alert.success("Data berhasil dihapus");
                this.loadDataTujuan();
                this.loadData();
                this.state.isModalShowDelete=false;


                return;
            })
            .catch(error => {
                console.log(error)
                this.setState({ isLoading: false })
                Alert.error("Gagal terhubung ke server!")
            })
    }

    handleSubmitButton() {
        
        const params = qs.stringify({
            thn_ajar_value: this.state.thn_ajar_value,
            kelas_id_tujuan:this.state.kelas_id_tujuan,
            kelas_id:this.state.kelas_id,
            user_id:localStorage.SISMART_USER_ID,
            siswa_selected:Object.keys(this.selected)

        })
        
        const url ='/siswa/naik_kelas';
        		
		axios
			.post(url, params)
			.then(response => {
				const result = response.data;

				if (result.success) {
                    Alert.success(result.message);
                    
                this.loadDataTujuan();
                this.loadData();
                this.state.isModalShow=false;
                this.selected=[];
			        // window.location.reload()
                    // this.props.history.replace('/diskoniuran/penetapan/'+this.props.match.params.diskon_id+'/'+this.props.match.params.diskon_nama);
					
				} else {
					if (Array.isArray(result.message)) {
						result.message.map(item => {
                            
                            this.state.isModalShow=false;
                            this.selected=[];
							Alert.error(item);

							return true;
						});
					} else {
                        
                        this.state.isModalShow=false;
                        this.selected=[];
						Alert.error(result.message);
					}

					this.setState({ isButtonLoading: false });
				}
			})
			.catch(error => {
				console.log("ERROR", error);
				Alert.error("Gagal terhubung ke server!");
				this.setState({ isButtonLoading: false });
			});
			this.setState({ showformAdd: false });
    }

    handlePageClick(data) {

        let selected = data.selected; // zero based index

        this.setState({ currentPage: selected }, () => {
            this.loadData();
        });
    }

    handlePageClickTujuan(data) {

        let selected = data.selected; // zero based index

        this.setState({ currentPageTujuan: selected }, () => {
            this.loadDataTujuan();
        });
    }

    loadDataKelasAsal(){
        axios.post("/kelas")
            .then(response => {
                return response.data.data.map(item => ({
                    key : item.kelas_id,
                    value : item.kelas_nama
                }))
            })
            .then(result => {
                this.setState({
                    dataKelasAsal: result,
                })
            })
            .catch(error => {
                console.log(error)
            })
    }

    loadDataKelasTujuan(){
        axios.post("/kelas")
            .then(response => {
                return response.data.data.map(item => ({
                    key : item.kelas_id,
                    value : item.kelas_nama
                }))
            })
            .then(result => {
                this.setState({
                    dataKelasTujuan: result,
                })
            })
            .catch(error => {
                console.log(error)
            })
    }

    loadDataTahunAjar(){
        axios.post("/thn_ajar_new")
            .then(response => {
                return response.data.data.map(item => ({
                    key : item.thn_ajar_value,
                    value : item.thn_ajar_value+" "+item.thn_ajar_semester.toUpperCase()
                }))
            })
            .then(result => {
                this.setState({
                    data_tahun_ajar: result,
                })
            })
            .catch(error => {
                console.log(error)
            })
    }

    handleChange(event) {
        
        const target = event.target;
        const value  = target.value;
        const name   = target.name;

        this.setState({
            [name] : value,
        })
      
    }
    
    handleChangeOptionTrue(event, siswa_id) {
            
        this.selected = this.selected || {};
        if (event.target.checked) {
            this.selected[siswa_id] = true;
        } else {
          delete this.selected[siswa_id];
        }

        /*console.log(Object.keys(this.selected));*/

    }

    handleChangeOptionAll(event) {

        this.selected = this.selected || {};
        if (event.target.checked) {
            this.setState({
                isAll: !this.state.isAll
            });
            this.state.data_siswaKelas.map(item=>{
                this.selected[item.siswa_id] = true;
            })
        } else {
            this.setState({
                isAll: false
            });
            this.state.data_siswaKelas.map(item=>{
                delete this.selected[item.siswa_id];
            })

        }


    }
    
    loadData() {

        this.setState({ isLoading: true })

        const params = qs.stringify({
            page: this.state.currentPage + 1,
            kelas_id : this.state.kelas_id
        })
        
        axios({
            method: 'post',
            url: '/siswa_data_kelas?' + params
        })
        .then((response) => {

            const result = response.data

            if (result.success === true) {                
                
                this.setState({
                    data_siswaKelas : result.data.data,
                    pageCount  : result.data.last_page,
                    isLoading  : false 
                })
                this.selected=[],
                this.loadDataTujuan()
            }
            else {
           
                Alert.error(result.message)
                this.setState({ isLoading: false })
            }      
        })
        .catch((error) => {
            console.log(error)
            this.selected=[]
            this.setState({ isLoading: false })
            Alert.error("Gagal terhubung ke server!")
        })
    }

    loadDataTujuan() {

        this.setState({ isLoading: true })

        const params = qs.stringify({
            page: this.state.currentPageTujuan + 1,
            kelas_id : this.state.kelas_id_tujuan,
            thn_ajar_value: this.state.thn_ajar_value
        })
        
        axios({
            method: 'post',
            url: '/siswa_data_kelas_tujuan?' + params
        })
        .then((response) => {

            const result = response.data

            if (result.success === true) {
                this.setState({
                    data_siswaKelas_tujuan : result.data.data,
                    thn_ajar_value : result.tahun_ajar.thn_ajar_value,
                    pageCountTujuan : result.data.last_page,
                    isLoading  : false 
                })
                this.selected=[]
            }
            else {
           
                Alert.error(result.message)
                this.setState({ isLoading: false })
                this.selected=[]
            }      
        })
        .catch((error) => {
            console.log(error)
            this.selected=[]
            this.setState({ isLoading: false })
            Alert.error("Gagal terhubung ke server!")
        })
    }
    
    componentDidMount() {
        
		if(localStorage.SISMART_USER_LEVEL !=='administrator'){
			this.props.history.replace("/dashboard");
        }
        
        this.loadData();
        this.loadDataKelasAsal();
        this.loadDataKelasTujuan();
    }

    componentDidUpdate(prevProps, prevState) {

        if (prevState.kelas_id !== this.state.kelas_id ||
            prevState.kelas_id_tujuan !== this.state.kelas_id_tujuan  ) {
            this.loadData(),
            this.loadDataTujuan(),
            this.setState({
                isAll: false
            });
        }
    }

    render () {

        return (         
            <div className="col-sm-12">

                <ModalHelp
                    isShow={this.state.isModalHelpShow}
                    toggleModal={this.toggleModalHelp}
                    handleSubmit={this.handleSubmitDeleteButton}
                    modalHeaderText="Tutorial Penggunaan Fitur"
                    modalBodyText={this.state.tutorial}
                    modalSubmitText="Ya" />
                <CustomModal
                    isShow={this.state.isModalShow}
                    toggleModal={this.toggleModal}
                    handleSubmit={this.handleSubmitButton}
                    modalHeaderText="Data Pindah Kelas"
                    modalBodyText={"Konfirmasi pindah kelas"}
                    modalSubmitText="Ya" />
                
                
                <CustomModal
                    isShow={this.state.isModalShowDelete}
                    toggleModal={this.toggleModalDelete}
                    handleSubmit={this.handleSubmitDeleteButton}
                    modalHeaderText="Hapus Data"
                    modalBodyText="Anda yakin ingin menghapus data ini?"
                    modalSubmitText="Ya" />

                <div className="card">
                    <div className="card-header">
                        Data Mutasi Kelas
                        <button
                            type="button"
                            title='Tutorial'
                            className="btn btn-danger btn-sm"
                            style={{ float: 'right'}}
                            onClick={() => {
                                this.toggleModalHelp();
                                // this.setState({ tutorial: levelName});
                            }}
                        >
                            <i className="fa fa-question-circle"s></i>
                        </button>
                    </div>
                    <div className="card-block">
                        <div className="form-group row">

                            <div className="col-md-3">
                                <FormDropdown
                                    items={this.state.dataKelasAsal}
                                    onChange={this.handleChange}
                                    value={this.state.kelas_id.toString()}
                                    placeholder={"Pilih Kelas Asal"}
                                    name="kelas_id"
                                />
                            </div>

                            <div className="col-md-3">
                                <FormDropdown
                                    items={this.state.dataKelasTujuan}
                                    onChange={this.handleChange}
                                    value={this.state.kelas_id_tujuan.toString()}
                                    placeholder={"Pilih Kelas Tujuan"}
                                    name="kelas_id_tujuan"
                                />
                            </div>

                            {/* <div className="col-md-3">
                                <label>Tahun Ajar</label>
                            </div> */}
                            
                            <div className="col-md-3">
                                {/* <label>Tahun Ajar</label> */}
                                <input 
                                    name="thn_ajar_value"
                                    type="text"
                                    disabled
                                    className="form-control"
                                    placeholder="Tahun Ajar" 
                                    onChange={this.handleChange} 
                                    value={this.state.thn_ajar_value} />
                            </div>

                            <div className="col-md-3">
                                <button 
                                    type="button" 
                                    className="btn btn-md btn-primary"
                                    disabled={this.state.isButtonLoading && "disabled"}
                                    // onClick={this.handleSubmit}
                                    onClick={() => {
                                        this.toggleModal();
                                    }}
                                >
                                    {this.state.isButtonLoading ? "Loading" : "Simpan"}
                                </button>
                            </div>
                        </div>
                        <hr/>
                        <div className="form-group row">
                        <div className="col-md-6 ">
                                {
                                    this.state.isLoading ? "Memuat Data..." : (
                                        this.state.data_siswaKelas.length == 0 ? "Data Kosong..." : (
                                            <div className='card'>
                                                <div className="card-header">
                                                    Data Lama
                                                </div>
                                                <div>
                                                    <table className="table table-striped table-bordered animated fadeIn">
                                                        <thead>
                                                            <tr>
                                                                <th>
                                                                    All/check
                                                                    <input
                                                                        type="checkbox"
                                                                        value={this.state.isAll}
                                                                        onChange={e => this.handleChangeOptionAll(e)}
                                                                    />
                                                                </th>
                                                                <th>Nama</th>
                                                                <th>NISN</th>
                                                                <th>Kelas Asal</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {                                                 
                                                                this.state.data_siswaKelas.map((item, i) => {
                                                                    return (
                                                                        <tr className="checkbox"
                                                                            style={{ marginBottom:1}}
                                                                            key={`naik-kelas-${i}`}>
                                                                            <td>
                                                                                <input
                                                                                    type="checkbox"
                                                                                    value={item.siswa_id}
                                                                                    disabled={this.state.isAll}
                                                                                    onChange={e => this.handleChangeOptionTrue(e, item.siswa_id)}
                                                                                />
                                                                            </td> 
                                                                            <td>{item.user_nama}</td>
                                                                            <td>{item.siswa_nisn}</td>
                                                                            <td>{item.kelas_nama}</td>                                                                                                            
                                                                        </tr>
                                                                    )
                                                                })
                                                            }
                                                        </tbody>
                                                    </table>   

                                                           
                                                    <Paging
                                                        handlePageClick={this.handlePageClick.bind(this)}
                                                        pageCount={this.state.pageCount}
                                                        currentPage={this.state.currentPage}
                                                    />
                                                </div>
                                            </div>
                                        )
                                    )
                                }
                            </div><div className="col-md-6">
                                {
                                    this.state.isLoading ? "Memuat Data..." : (
                                        this.state.data_siswaKelas_tujuan.length === 0 ? "Data Kosong..." : (
                                            <div className='card'>
                                                <div className="card-header">
                                                    Data Baru
                                                </div>
                                                <div>
                                                    <table className="table table-striped table-bordered animated fadeIn">
                                                        <thead>
                                                            <tr>
                                                                <th>Nama</th>
                                                                <th>NISN</th>
                                                                <th>Kelas Tujuan</th>
                                                                <th>Aksi</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {                                                    
                                                                this.state.data_siswaKelas_tujuan.map((item) => {

                                                                    return (
                                                                        <tr key={item.siswa_id}>
                                                                            <td>{item.user_nama}</td>
                                                                            <td>{item.siswa_nisn}</td>
                                                                            <td>{item.kelas_nama}</td>  
                                                                            <td>
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-danger btn-sm"
                                                                                    onClick={() => {
                                                                                        this.toggleModalDelete();
                                                                                        this.setState({ siswa_id: item.siswa_id});
                                                                                    }}
                                                                                >
                                                                                    Hapus
                                                                                </button>
                                                                            </td>                                                                                                            
                                                                        </tr>
                                                                    )
                                                                })
                                                            }
                                                        </tbody>
                                                    </table>   

                                                    <Paging
                                                        handlePageClick={this.handlePageClickTujuan.bind(this)}
                                                        pageCount={this.state.pageCountTujuan}
                                                        currentPage={this.state.currentPageTujuan}
                                                    />
                                                </div>
                                            </div>
                                        )
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>                   
        )
    }
}

export default Lists;



// WEBPACK FOOTER //
// ./src/views/NaikKelas/Lists.js